<template>
    <div>
        <div
            aria-hidden="true"
            aria-labelledby="modalFillInLabel"
            class="modal modal-note animation opacity"
            id="modal-notes"
            role="dialog"
            tabindex="-1"
        >
            <div v-if="mode === 'list'" id="modal-list-note" class="modal-dialog modal-lg">
                <div class="modal-content">
                    <header class="modal-header">
                        <div class="has-popover">
                            <span class="modal-title h3">{{ __('Notes') }}</span>

                            <popover class="popover">
                                <strong slot="header">{{ __('How to work with notes?') }}</strong>
                                <div class="popover__text" slot="content">
                                    <p>{{ __('This record serves as a list of the notes you have created for a given patient. Your notes are private and no one but you has access to them.') }}</p>

                                    <p v-html="__('In the details of each note, there is an option to create a reminder for that day\'s note, which will be reminded on the main <strong>\'My Dashboard\'</strong> page as your assignment.')"></p>
                                </div>
                            </popover>
                        </div>

                        <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                            <svg-icon icon="close-modal" />
                        </button>
                    </header>
                    <div class="modal-body">
                        <VButton :label="__('New note')" @onClick="mode = 'new'" position="center" v-impersonate-protect-exclude-substitute />

                        <div class="notes-list">
                            <article v-for="note in notes" :key="note.id" class="note-item">
                                <a href="#" @click.prevent="edit(note)" :class="[{'disabled': user.is_impersonating && !user.is_substitute}]">
                                    <header>
                                        <div class="note-title">{{ note.name }}</div>
                                        <div class="note-date" v-if="note.date && moment(note.date).isValid()">
                                            <span>{{ moment(note.date).format('D. MMMM') }}</span>
                                            <figure>
                                                <svg width="18" height="16" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9 1.848c3.785 0 6.864 3.01 6.864 6.71a6.62 6.62 0 01-2.082 4.812l1.487 1.615c.23.25.21.634-.046.859a.629.629 0 01-.879-.045l-1.53-1.663A6.935 6.935 0 019 15.27a6.935 6.935 0 01-3.814-1.134l-1.53 1.662a.626.626 0 01-.463.202.627.627 0 01-.416-.156.599.599 0 01-.046-.86L4.22 13.37a6.62 6.62 0 01-2.083-4.81c0-3.7 3.08-6.711 6.864-6.711zM8.294 5.09c-.438 0-.794.332-.794.741V9.44c0 .41.356.742.794.742h2.912c.438 0 .794-.332.794-.742s-.356-.741-.794-.741H9.088V5.832c0-.41-.355-.741-.794-.741zM5.371.886C4.134-.297 2.14-.295.929.891A3.03 3.03 0 000 3.088c.005.818.336 1.583.933 2.155a.628.628 0 00.875-.004L5.376 1.75a.602.602 0 00-.004-.865zm11.7.005C15.858-.295 13.865-.297 12.63.886a.602.602 0 00-.004.865l3.566 3.487c.122.12.281.178.44.178a.626.626 0 00.436-.173A2.983 2.983 0 0018 3.088a3.032 3.032 0 00-.929-2.197z"
                                                        fill="#FF3E57"
                                                        fill-rule="nonzero"
                                                    />
                                                </svg>
                                            </figure>
                                        </div>
                                    </header>

                                <span class="note-created_at">
                                    {{ noteDate(note) }}
                                    <span>({{ note.coach | fullname }})</span>
                                </span>

                                    <p class="note-body">{{ note.body }}</p>
                                </a>

                                <footer v-impersonate-protect-exclude-substitute>
                                    <a href="#" @click.prevent="edit(note)">
                                        <!-- TODO extract svg -->
                                        <svg
                                            aria-hidden="true"
                                            focusable="false"
                                            height="17"
                                            widht="17"
                                            data-prefix="fas"
                                            data-icon="pencil-alt"
                                            class="svg-inline--fa fa-pencil-alt fa-w-16"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                        >
                                            <path
                                                fill="#B9B7C7"
                                                d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                                            ></path>
                                        </svg>
                                        <span>{{ __('Edit note') }}</span>
                                    </a>

                                    <a v-if="isMainCoach(note)" href="#" @click.prevent="deleteNote(note)">
                                        <!-- TODO extract svg -->
                                        <svg
                                            aria-hidden="true"
                                            height="17"
                                            width="15"
                                            focusable="false"
                                            data-prefix="fas"
                                            data-icon="trash-alt"
                                            class="svg-inline--fa fa-trash-alt fa-w-14"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                        >
                                            <path
                                                fill="#B9B7C7"
                                                d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                                            ></path>
                                        </svg>
                                        <span>{{ __('Delete note') }}</span>
                                    </a>
                                </footer>
                            </article>
                        </div>
                    </div>
                </div>
            </div>

            <notes-form-new
                v-if="mode === 'new'"
                :patient-id="patientId"
                @created="addNote"
                @mode="setMode"
                :note="note"
            ></notes-form-new>
            <notes-form-edit
                v-if="mode === 'edit'"
                :patient-id="patientId"
                @mode="setMode"
                @update="update"
                :note="note"
            ></notes-form-edit>
        </div>

        <notes-form-delete
            v-if="mode === 'delete'"
            :patient-id="patientId"
            @mode="setMode"
            @remove="remove"
            :note="note"
        ></notes-form-delete>
    </div>
</template>

<script>
    import NotesFormNew from './NotesFormNew.vue'
    import NotesFormEdit from './NotesFormEdit.vue'
    import NotesFormDelete from './NotesFormDelete.vue'
    export default {
        components: {
            NotesFormNew,
            NotesFormEdit,
            NotesFormDelete
        },
        props: {
            patientId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                notesList: [],
                mode: 'list',
                note: null
            }
        },
        mounted() {
            this.fetch()
        },  
        computed: {
            notes() {
                return this.notesList.sort((a, b) => {
                    let dateA = new Date(a.updated_at.date);
                    let dateB = new Date(b.updated_at.date);

                    return dateB - dateA;
                });
            }
        },
        methods: {
            fetch() {
                axios.get(`/coaches/patients/${this.patientId}/notes`)
                    .then((res) => {
                        this.notesList = res.data.notes
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },
            addNote() {
                this.fetch()
                this.mode = 'list'
            },
            edit(note) {
                this.mode = 'edit'
                this.note = note
            },
            deleteNote(note) {
                this.mode = 'delete'
                this.note = note
            },
            update() {
                this.fetch()
                this.mode = 'list'
            },
            remove() {
                const rolePrefix = this.user.role === 'coach' ? 'coaches' : 'doctors'

                axios.delete(`/${rolePrefix}/patients/${this.patientId}/notes/${this.note.id}`)

                this.notesList = this.notesList.filter((n) => n.id !== this.note.id)
                this.mode = 'list'
            },
            setMode(mode) {
                this.mode = mode
            },
            noteDate(note) {
                if(moment(note.created_at.date).isSame(moment(note.updated_at.date))) {
                    return lang.get("Created") +" "+ moment(note.created_at.date).format('D. MMMM YYYY HH:mm')
                } else {
                    return lang.get("Updated") +" "+ moment(note.updated_at.date).format('D. MMMM YYYY HH:mm')
                }
            },
            isMainCoach(note) {
                if(this.user.is_impersonating && this.user.is_substitute && this.user.impersonator && this.user.impersonator.coach_id !== note.coach.id) {
                    return false
                } else {
                    return true
                }
            }
        }
    }
</script>
